import { Injectable } from '@angular/core';

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// export let testVar = "fdfsd";

/**
 * VBScript hint
 *
 * @export
 * @class VBScriptHint
 */
@Injectable({
  providedIn: 'root'
})
export class VBScriptHint {
  /**
   * testVariable
   *
   * @memberof VBScriptHint
   */
  testVar = 'testes';
  /**
   * custom keywords for vbScript in a pipe dilimited list
   *
   * @memberof VBScriptHint
   */
  // tslint:disable-next-line: max-line-length
  originalVBScriptKeywords =
    'Field =|If|Else|ElseIf|End If|Then|Dim|Parse.TryParseDateTime(, dt)|Parse.TryParseDecimal(, d)|ToString|Select Case Variable_Name\n	Case ""\n 		Field = ""\n	Case Else\n 		Field = ""\nEnd Select|MMddyyyy|MM/dd/yyyy|MM-dd-yyyy|MMddyy|MM/dd/yy|MM-dd-yy|MXR("", Variable_Name)'.split(
      '|'
    );

  /**
   * VbScript keywords
   *
   * @memberof VBScriptHint
   */
  vbscriptKeywords: any = [];

  /**
   * Creates an instance of VBScriptHint.
   * @memberof VBScriptHint
   */
  constructor() {
    const CodeMirror = require('../../../../../node_modules/codemirror');
    const Pos = CodeMirror.Pos;
    function forEach(arr: any, f: any) {
      for (let i = 0, e = arr.length; i < e; ++i) {
        f(arr[i]);
      }
    }

    function arrayContains(arr: any, item: any) {
      if (!Array.prototype.indexOf) {
        let i = arr.length;
        while (i--) {
          if (arr[i] === item) {
            return true;
          }
        }
        return false;
      }
      return arr.indexOf(item) !== -1;
    }

    /**
     * Script Hint
     *
     * @param {*} editor
     * @param {*} keywords
     * @param {*} getToken
     * @param {*} options
     * @returns
     */
    function scriptHint(
      editor: any,
      keywords: any,
      getToken: any,
      options: any
    ): any {
      // Find the token at the cursor
      const cur = editor.getCursor();
      let token = getToken(editor, cur);
      if (/\b(?:string|comment)\b/.test(token.type)) {
        return;
      }
      const innerMode = CodeMirror.innerMode(editor.getMode(), token.state);
      if (innerMode.mode.helperType === 'json') {
        return;
      }
      token.state = innerMode.state;

      // If it's not a 'word-style' token, ignore the token.
      if (!/^[\w$_]*$/.test(token.string)) {
        token = {
          start: cur.ch,
          end: cur.ch,
          string: '',
          state: token.state,
          type: token.string === '.' ? 'property' : null
        };
      } else if (token.end > cur.ch) {
        token.end = cur.ch;
        token.string = token.string.slice(0, cur.ch - token.start);
      }

      let tprop = token;
      // If it is a property, find out what it is a property of.
      const context = [];
      while (tprop.type === 'property') {
        tprop = getToken(editor, Pos(cur.line, tprop.start));
        if (tprop.string !== '.') {
          return;
        }
        tprop = getToken(editor, Pos(cur.line, tprop.start));
        if (!context) {
        }
        context.push(tprop);
      }
      return {
        list: getCompletions(token, context, keywords, options),
        from: Pos(cur.line, token.start),
        to: Pos(cur.line, token.end)
      };
    }

    /**
     * Vbscript Hint
     *
     * @param {*} editor
     * @param {*} options
     * @returns
     */
    const vbscriptHint = (editor: any, options: any): any => {
      return scriptHint(
        editor,
        this.vbscriptKeywords,
        function (e: any, cur: any) {
          return e.getTokenAt(cur);
        },
        options
      );
    };
    CodeMirror.registerHelper('hint', 'vbscript', vbscriptHint.bind(this));

    /**
     * ForAllProps
     *
     * @param {*} obj
     * @param {*} callback
     */
    function forAllProps(obj: any, callback: any) {
      if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) {
        // tslint:disable-next-line: forin
        for (const name in obj) {
          callback(name);
        }
      } else {
        for (let o = obj; o; o = Object.getPrototypeOf(o)) {
          Object.getOwnPropertyNames(o).forEach(callback);
        }
      }
    }

    /**
     * Get Completions
     *
     * @param {*} token
     * @param {*} context
     * @param {*} keywords
     * @param {*} options
     * @returns
     */
    function getCompletions(
      token: any,
      context: any,
      keywords: any,
      options: any
    ) {
      // console.log(window);
      const found: any = [],
        start = token.string,
        global = options && options.globalScope;
      // console.log(found);
      function maybeAdd(str: any) {
        // console.log(start);
        if (
          str.toLowerCase().lastIndexOf(start.toLowerCase(), 0) === 0 &&
          !arrayContains(found, str)
        ) {
          found.push(str);
        }
      }
      // function gatherCompletions(obj) {
      //     // tslint:disable-next-line: max-line-length
      //     const stringProps = '';
      //     const arrayProps = [];
      //     const funcProps = '';
      //     console.log(obj);
      //     // tslint:disable-next-line: max-line-length
      // tslint:disable-next-line: max-line-length
      //     if (typeof obj === 'string') { forEach(stringProps, maybeAdd); } else if (obj instanceof Array) { forEach(arrayProps, maybeAdd); } else if (obj instanceof Function) { forEach(funcProps, maybeAdd); }
      //     forAllProps(obj, maybeAdd);
      // }

      if (context && context.length) {
        // If this is a property, see if it belongs to some object we can
        // find in the current environment.
        const obj = context.pop();
        let base;
        if (obj.type && obj.type.indexOf('variable') === 0) {
          if (options && options.additionalContext) {
            base = options.additionalContext[obj.string];
          }
          if (!options || options.useGlobalScope !== false) {
            base = base || global[obj.string];
          }
        } else if (obj.type === 'string') {
          base = '';
        } else if (obj.type === 'atom') {
          base = 1;
        } else if (obj.type === 'function') {
          if (
            global.jQuery != null &&
            (obj.string === '$' || obj.string === 'jQuery') &&
            typeof global.jQuery === 'function'
          ) {
            base = global.jQuery();
          } else if (
            global._ != null &&
            obj.string === '_' &&
            typeof global._ === 'function'
          ) {
            base = global._();
          }
        }
        while (base != null && context.length) {
          base = base[context.pop().string];
        }
        // if (base != null) { gatherCompletions(base); }
      } else {
        // If not, just look in the global object and any local scope
        // (reading into JS mode internals to get at the local and global variables)
        for (let v = token.state.localVars; v; v = v.next) {
          maybeAdd(v.name);
        }
        for (let v = token.state.globalVars; v; v = v.next) {
          maybeAdd(v.name);
        }
        // if (!options || options.useGlobalScope !== true) {
        //     gatherCompletions(global);
        // }
        forEach(keywords, maybeAdd);
      }
      return found;
    }
  }
}
